import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateFilterFn } from '@angular/material/datepicker';
import { UrlConstantsService } from '@pw-utils/services/url-constants/url-constants.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DisableDatesService {
  constructor(private _http: HttpClient, private _urls: UrlConstantsService, private _datePipe: DatePipe) { }

  public getDisableDates(): Observable<{ disabled_dates: string[] }> {
    return this._http.get<{ disabled_dates: string[] }>(this._urls.DISABLE_DATES);
  }

  public getDateFilter(
    disableDates: string[],
    fromStartDate: Date = new Date(),
    disableDatesCountFromStartDate: number = 0,
    type: 'pickup' | 'delivery' = 'pickup'): DateFilterFn<Date> {
    // console.log(`getDateFilter: ${fromStartDate} ${type}`);
    // console.log(`disableDates: ${disableDates}`);
    const firstAvailableDate = this._getFirstAvailableDate(fromStartDate, disableDatesCountFromStartDate);
    const isWeekends = (d: Date | null) => {
      return !!d && [0, 6].includes(d.getDay());
    };
    const beforeFirstAvailableDate = (d: Date | null) => {
      if (type === 'delivery')
        console.log(`${d} < ${firstAvailableDate}`);
      return d < firstAvailableDate;
    };
    const isTotalDisabled = (d: Date | null) => {
      const dd = this._datePipe.transform(d, 'dd.MM.yyyy');
      // console.log('isTotalDisabled')
      // console.log(disableDates)
      // console.log(dd)
      return disableDates.includes(dd);
    };
    return (d: Date | null) => {
      // console.log(`testing date ${d}`);
      // console.log(`!!d: ${!!d}`);
      // console.log(`!beforeFirstAvailableDate(d): ${!beforeFirstAvailableDate(d)}`);
      // console.log(`!isWeekends(d): ${!isWeekends(d)}`);
      // console.log(`!isTotalDisabled(d): ${!isTotalDisabled(d)}`);
      return !!d && !beforeFirstAvailableDate(d) && !isWeekends(d) && !isTotalDisabled(d);
    };
  }

  private _getFirstAvailableDate(fromStartDate: Date, dateOffsetFromToday: number = 0): Date {
    // const now = new Date();
    return new Date(
      fromStartDate.getFullYear(),
      fromStartDate.getMonth(),
      fromStartDate.getDate() + dateOffsetFromToday);
  }
}
